import React from "react";
import PropTypes from "prop-types";
import {Modal, Button} from "semantic-ui-react";
import { useTextResources } from "../../../language";

const EditEntityPopup = ({
    open,
    isCreate,
    header,
    children,
    onClose,
    onSave,
    onSaveAndClose,
    isLoading,
    isValidDateRange,
    ...rest
}) => {
    const text = useTextResources();
    return (
        <Modal
            open={open}
            onClose={onClose}
            dimmer
            centered
            closeOnEscape
            closeOnDimmerClick
            {...rest}
        >
            <Modal.Header content={header ?? (isCreate ? text("Create") : text("Edit"))} />
            <Modal.Content>
                {children}
            </Modal.Content>
            <Modal.Actions>
                <Button negative onClick={onClose} loading={isLoading}>
                    {text("Close")}
                </Button>
                {onSaveAndClose && (
                <Button disabled={!isValidDateRange} positive onClick={onSaveAndClose} loading={isLoading}>
                    {text("Saveandclose")}
                </Button>
                )}
                {onSave && (
                <Button disabled={!isValidDateRange} positive onClick={onSave} loading={isLoading}>
                    {text("Save")}
                </Button>
                )}
            </Modal.Actions>
        </Modal>
    );
};

EditEntityPopup.propTypes = {
    open: PropTypes.bool.isRequired,
    isCreate: PropTypes.bool.isRequired,
    header: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    children: PropTypes.element.isRequired,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func,
    onSaveAndClose: PropTypes.func,
    isLoading: PropTypes.bool,
    isValidDateRange: PropTypes.bool,
};

EditEntityPopup.defaultProps = {
    open: false,
    isCreate: true,
    header: undefined,
    onSave: undefined,
    onSaveAndClose: undefined,
    isLoading: false,
    isValidDateRange: true,
};

export default EditEntityPopup;
